<template>
  <v-container>
    <v-card>
      <v-card-title>Artist Collections</v-card-title>
      <v-card-text v-for="artist of artists" :key="artist.artistCode">
        <h2 class="mb-4">{{artist.name}}</h2>
          <h3 v-for="collection of artist.artistCollections">
            {{collection.collectionId}} {{ collection.collectionName }}
          </h3>
      </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import ArtistDialog from './components/ArtistDialog'
import ArtistApi from '@/api/admin/artist'

export default {
  components: {
    ArtistDialog
  },
  data() {
    return {
      openDialog: false,
      artists: [],
      artistCodes: [],
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Code', value: 'artistCode', width: 100 },
        { text: 'Signature Image', value: 'signatureImage' },
        { text: 'Status', value: 'status' },
      ],
      selectedFile: null,
      validData: false,
      valid: true,
      processing: false,
      progress: 0,
      uploadSuccess: false,
      currentArtist: null,
      mode: 'preview'
    }
  },
  async created() {
    await this.loadArtists()
  },
  mounted: function () {
  },
  computed: {
  },
  watch: {},
  methods: {
    loadArtists() {
      ArtistApi.loadAllArtists().then((results) => {
        this.artists = results.data
        this.artistCodes = this.artists.map(item => item.artistCode)
        this.loadingData = false
      }).catch(
        err => {
          console.log('err', err)
          this.loadingData = false
        }
      )
    },
    createArtist() {
      this.currentArtist = null
      this.openDialog = true
    },
    editArtist(evt) {
      this.currentArtist = evt
      this.openDialog = true
    },
    closeDialog(element) {
      this.loadArtists()
      this.openDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep tbody tr :hover {
  cursor: pointer;
}
</style>
